import React from 'react'
import PropTypes from 'prop-types'
import { Paper } from '@mui/material'

const AutocompletePopupPaper = React.forwardRef(({ children, ...paperProps }, ref) => {
  if (React.Children.toArray(children).length === 0) return null
  return (
    <Paper {...paperProps} ref={ref}>
      {children}
    </Paper>
  )
})

AutocompletePopupPaper.displayName = 'AutocompletePopupPaper'

AutocompletePopupPaper.propTypes = {
  children: PropTypes.node
}

export default AutocompletePopupPaper
